export default __webpack_public_path__ + "static/media/baseline-keyboard_arrow_right-24px.da657029.svg";